import * as types from '../mutation-types'

export default {
	namespaced: true,
	state: {
		tasks: []
	},

	actions: {
		fetchAll ({ commit }, { fromDate, toDate, projectIds, no, description, tags, userId, workdayIds, approved, Page, PerPage }) {
			var urlSearchParams = new URLSearchParams();
			var params = { fromDate, toDate, no, description, userId, approved, Page, PerPage }

			Object.keys(params).forEach(param => {
				if (params[param] !== null && params[param] !== undefined) urlSearchParams.append(param, params[param])
			});
			projectIds.forEach(id => {
				urlSearchParams.append('projectIds', id)
			})
			// workdayIds.forEach(id => {
			// 	urlSearchParams.append('workdayIds', id)
			// })
			// tags.forEach(id => {
			// 	urlSearchParams.append('tags', id)
			// })
			return window.axios.get('/Tasks', { params: params }).then(({ data }) => {
				commit(types.STORE_TASKS, data)
				return data 
			})
		},

		fetchById ({ commit }, { id }) {
			return window.axios.get('/Tasks', { id }).then((data) => { return data })
		},

		create ({ commit }, { description, projectId, taskNo, planId, start, end, durationInMinute, workdayId,	isApproved, tagIds, workFromHome }) {
			return window.axios.post('/tasks', { description, projectId, taskNo, planId, start,	end, durationInMinute,		workdayId,	isApproved, tagIds, workFromHome }).then(({ data }) => {
				return data
			})
		},

		update ({ commit }, { id, description, projectId, taskNo, planId, start, end, durationInMinute, workdayId, isApproved, tagIds, workFromHome }) {
			return window.axios.put(`/tasks/${id}`, { description, projectId, taskNo, planId, start, end, durationInMinute, workdayId, isApproved, tagIds, workFromHome }).then(({ data }) => {
				return data
			})
		},

		delete ({ commit }, { id }) {
			return window.axios.delete(`/tasks/${id}`).then((data) => {
				return data
			})
		}
	},

	mutations: {
		[types.STORE_TASKS] (state, tasks) {
			state.tasks = tasks
		}
	}
}
